import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledLink = styled.a`
    gap: 4px;
    color: ${colorsPalettes.blue[400]};
`;
